<template lang="pug">
transition(name="dawn-panel")
  .dawn-panel(@click.stop, v-show="show")
    .dawn-panel-top
      span.close-icon(@click="close")
        i.fal.fa-times
    .dawn-panel-header
      h3.title {{title}}
      p.subtitle {{subtitle}}
    slot(name="body")
    .dawn-panel-footer.text-right
      slot(name="footer")
      div(v-if="!hasSlotFooter")
        ed-button.btn.btn-secondary(@click="close", v-if="secondaryButton != 'false'") {{secondaryButton}}
        ed-button.btn.btn-primary(@click="close", v-if="primaryButton != 'false'") {{primaryButton}}
</template>

<script>

import PerfectScrollbar from 'perfect-scrollbar'

export default {
  name: 'ed-panel',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: String,
    primaryButton: {
      type: String,
      default: 'Ok'
    },
    secondaryButton: {
      type: String,
      default: 'Cancel'
    }
  },
  data: function () {
    return {
      body: null,
      footer: null
    }
  },
  methods: {
    close: function () {
      this.$emit('close')
    }
  },
  mounted: function () {
    const viewport = this.$el

    this.psViewport = new PerfectScrollbar(viewport, {
      minScrollbarLength: 20,
      wheelPropagation: false
    })

    document.addEventListener('keydown', (e) => {
      if (this.show && e.keyCode === 27) {
        this.close()
      }
    })
  },
  updated() {
    this.psViewport.update()
  },
  computed: {
    hasSlotFooter() {
      return this.$slots.footer
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/sass/_variables.scss";

.dawn-panel {
  text-align: left;
  padding: 1rem 2.5rem 1rem 1.5rem;
  @include theme { background: v(canvas) }
  box-shadow: $box-shadow;
  position: fixed;
  width: 500px;
  top: 0;
  right: 0;
  margin-top: 0;
  border-radius: 3px 0px 0px 3px;
  z-index: 999999;
  height: 100%;
  overflow: auto;

  >>> .ps__rail-y {
    right: 20px !important;
  }

  h3.title {
    font-weight: $font-weight-extra-bold;
    font-size: $font-size-base-lg;
    margin-top: 0;
  }

  p.subtitle {
    font-weight: normal;
    font-size: $font-size-base;
  }
}

.dawn-panel-top {
  text-align: right;
  margin-bottom: -15px;

  span.close-icon {
    font-weight: 100;
    @include theme {
    color: v(ink);
    }
    margin-top: .5rem;
    margin-left: 2rem;
    margin-right: 1rem;
    text-align: right;
    &:hover {
      cursor: pointer;
    }
  }
}

.dawn-panel-body {
  margin: 1rem 0;
}

.text-right {
  text-align: right;
}

.dawn-panel-enter-active, .dawn-panel-leave-active {
  transition: all .6s ease-in-out;
}

.dawn-panel-enter,.dawn-panel-leave-to {
  right: -500px;
}

.dawn-panel-leave,.dawn-panel-enter-to {
  right: 0px;
}

</style>



// WEBPACK FOOTER //
// src/core/components/edPanel/index.vue